import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { ParticipantDetail } from 'components/common/SideBar/Participants/ParticipantDetail';
import { useViewport } from 'utils/getViewport/getViewport';
import { PanelHeader } from 'components/common/Panel/Header';
import AddParticipant from '../../../threepp/assessment/Question/ParticipantPopover/AddParticipant';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: '4rem'
  },
  participantsDetails: {
    height: 'calc(100vh - 160px)',
    overflowY: 'auto',
    [theme.breakpoints.down(theme.breakpoints.values.mobile)]: {
      height: 'calc(100  * var(--vh) - 44px)'
    }
  }
}));

export const ParticipantsDetails = ({ participantsData, currentUser, isAssessmentDisabled, isOwner, onDeleteUser, onUpdateUser, activeUsers }) => {
  const { isMobile } = useViewport();
  const { t } = useTranslation();
  const classes = useStyles();

  const ownersCount = participantsData.filter(participant => participant.isOwner === true).length;
  // eslint-disable-next-line no-return-assign, no-param-reassign
  participantsData.map(participant => (participant.isCurrentUser = participant.email === currentUser.email));
  participantsData.sort((a, b) => b.isCurrentUser - a.isCurrentUser);
  const participantDetail = participantsData.map((data, index) => (
    <ParticipantDetail
      // eslint-disable-next-line react/no-array-index-key
      key={index}
      participant={data}
      currentUser={currentUser}
      isOwner={isOwner}
      disabled={isAssessmentDisabled}
      ownersCount={ownersCount}
      onDeleteUser={onDeleteUser}
      onUpdateUser={onUpdateUser}
      isOnline={activeUsers && activeUsers.includes(data.email)}
    />
  ));

  return (
    <div className={!isMobile ? `sidebar-none col-right ${classes.root}` : ''}>
      <Paper className={classes.participantsDetails}>
        <PanelHeader title={t('assessment.filters.participantFilter.title')} content={!isAssessmentDisabled && <AddParticipant />} />
        {participantDetail}
      </Paper>
    </div>
  );
};
